import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    menuItems: [
      { name: 'Home', to: '/', home: false },
      { name: 'Returns', to: '/return-authorisation' },
      { name: 'RA Express Form', to: '/return-authorisation-express-form', side: false },
      { name: 'RA User Form', to: '/warranty-request', side: false },
      { name: 'Products', to: '/products' },
      { name: 'Dealers', to: '/dealers' },
      { name: 'Dealer Locator', to: '/dealer-locator', side: false },
      { name: 'Admin Users', to: '/admin-users' }
    ],
    server: '/api/index.php',
    devServer: 'http://localhost/vms-ra/api/index.php',
    googleApiKey: 'AIzaSyAIG_wucCkX1rVfOgFxUA9BeYJKXeKpAiM',
    uid: -1
  },
  getters: {
    user (state) { return state.user },
    uid (state) { return state.uid },
    menuItems (state) { return state.menuItems },
    googleApiKey (state) { return state.googleApiKey },
    server (state) {
      // return state.server
      if (window.location.hostname === 'localhost') {
        return state.devServer
      } else {
        return state.server
      }
    }
  },
  mutations: {
    SET_USER (state, payload) { state.user = payload },
    SET_UID (state, payload) { state.uid = payload }
  },
  actions: {
    setUser (context, payload) { context.commit('SET_USER', payload) },
    setUid (context, payload) { context.commit('SET_UID', payload) }
  }
})
